import type { Booking } from '~/models';

import { useNuxtApp } from '#app';

const useBookingStore = defineStore('customer-booking', () => {
  const { $http } = useNuxtApp();

  const create = async (booking: Booking): Promise<Booking> => {
    return $http.booking.create(booking);
  };

  const getAvailableTimes = async (date: Date): Promise<string[]> => {
    return $http.booking.getAvailableTimes(date);
  };

  return {
    create,
    getAvailableTimes
  };
});

export { useBookingStore };
